module.exports = __webpack_public_path__ + "static/media/radio-img2.43fd0008.jpg";